"use client";

import { useEffect, useState } from "react";

/**
 * Campagne influenceur active pour le visiteur courant.
 *
 * RÈGLE PRODUIT (décision du 04/07/2026) : quand une campagne influenceur est
 * active pour le visiteur (lien créateur cliqué → cookie blvmy_ref, ou compte
 * parrainé par un affilié en campagne), TOUTE la communication promo flash
 * Believemy doit être masquée (bandeau, modale, boutons stylisés), même si la
 * promo flash est plus avantageuse. Le visiteur ne voit que l'offre du
 * créateur.
 *
 * Le fetch n'a lieu que si le cookie existe ou si l'utilisateur est connecté :
 * pour la grande majorité des visiteurs, ce hook ne coûte rien.
 */
export default function useInfluencerCampaign(hasSession = false) {
    const [campaign, setCampaign] = useState(null);
    const [campaignChecked, setCampaignChecked] = useState(false);

    useEffect(() => {
        const hasCookie =
            typeof document !== "undefined" &&
            document.cookie.includes("blvmy_ref=");

        if (!hasCookie && !hasSession) {
            setCampaignChecked(true);
            return;
        }

        let cancelled = false;

        fetch("/api/affiliate/get/campaign")
            .then((response) => response.json())
            .then((data) => {
                if (!cancelled) {
                    // Toujours écraser l'état : quand la session bascule
                    // (connexion d'un compte existant non parrainé dans le
                    // tunnel), le re-fetch renvoie active:false et la
                    // campagne affichée doit disparaître, sinon le récap
                    // montrerait un prix remisé que Stripe ne facturera pas.
                    setCampaign(data && data.active ? data : null);
                }
            })
            .catch(() => {
                // Pas de campagne : affichage normal
            })
            .finally(() => {
                if (!cancelled) {
                    setCampaignChecked(true);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [hasSession]);

    return { campaign, campaignChecked };
}
